class HelpTopic {

		static fromName(name) {
		let inst = new HelpTopic();

		inst.name = name;
		return inst;
	}

	static parse(md) {

		//hr
		md = md.replace(/(^---$)/gm, '<hr>\n');

		//ul
		md = md.replace(/^\s*\n-/gm, '<ul class="indent">\n-');
		md = md.replace(/^(-.+)\s*\n([^-])/gm, '$1\n</ul>\n\n$2');
		md = md.replace(/^-(.+)/gm, '<li>$1</li>');
		
		//ol
		md = md.replace(/^\s*\n(\d)\./gm, '<ol class="indent" start="$1">\n$1.');
		md = md.replace(/^(\d\..+)\s*\n([^\d\.])/gm, '$1\n</ol>\n\n$2');
		md = md.replace(/^\d\.(.+)/gm, '<li>$1</li>');
		
		//blockquote
		// md = md.replace(/^\>(.+)/gm, '<blockquote>$1</blockquote>');
		
		//h
		md = md.replace(/^[\#]{6}(.+)/gm, '<h6>$1</h6>');
		md = md.replace(/^[\#]{5}(.+)/gm, '<h5>$1</h5>');
		md = md.replace(/^[\#]{4}(.+)/gm, '<h4>$1</h4>');
		md = md.replace(/^[\#]{3}(.+)/gm, '<h3>$1</h3>');
		md = md.replace(/^[\#]{2}(.+)/gm, '<h2>$1</h2>');
		md = md.replace(/^[\#]{1}(.+)/gm, '<h1>$1</h1>');
		
		//alt h
		md = md.replace(/^(.+)\n\={1}$/gm, '<h1>$1</h1>');
		md = md.replace(/^(.+)\n\-{1}$/gm, '<h2>$1</h2>');

		//icons
		md = md.replace(/\§\[([^\]]+)\]/g, '<i class="i-rg i-$1"></i>');
		
		//images
		md = md.replace(/\!\[([^\]]+)\]\(([^\)]+)\)/g, '<img src="images/help/$2" class="step" alt="$1" />');

		//guide
		md = md.replace(/\%\[([^\]]+)\]\(([^\)]+)\)/g, (match, text, id) => {
			return '<div class="text-center"><button class="help-button help-button-steps" onclick="pageFlow.fromStart('+id+');" >' + text + '</button></div>'
		});
		
		//videos
		md = md.replace(/\$\[([^\]]+)\]\(([^\)]+)\)/g, (match, text, id) => {
			return '<div class="text-center"><button class="help-button help-button-video" onclick="loadHelpVideo('+id+');" >' + text + '</button></div>'
		});
		
		//help topics
		md = md.replace(/@[\[]{1}([^\]]+)[\]]{1}[\(]{1}([^\)\"]+)(\"(.+)\")?[\)]{1}/g, '<div class="help-forward" onclick="help.fromName(\'$2\')"><span class="tx-span">$1<i class="i-rg i-chev-right"></i></span></div>');
		
		//links
		md = md.replace(/[\[]{1}([^\]]+)[\]]{1}[\(]{1}([^\)\"]+)(\"(.+)\")?[\)]{1}/g, '<a target="_blank" href="$2" title="$4" rel="noopener">$1</a>');
		
		//font styles
		md = md.replace(/[\*\_]{2}([^\*\_]+)[\*\_]{2}/g, '<b>$1</b>');
		md = md.replace(/[\*\_]{1}([^\*\_]+)[\*\_]{1}/g, '<em>$1</em>');
		md = md.replace(/[\~]{2}([^\~]+)[\~]{2}/g, '<del>$1</del>');
		
		//pre
		md = md.replace(/^\s*\n\`\`\`(([^\s]+))?/gm, '<pre class="$2">');
		md = md.replace(/^\`\`\`\s*\n/gm, '</pre>\n\n');

		//notes
		md = md.replace(/^\s*\n\>\>\>(([^\s]+))?/gm, '<div class="help-note"><h4><i class="i-rg i-comment"></i> '+_("NOTE")+' </h4>');
		md = md.replace(/^\>\>\>\s*\n/gm, '</div>\n\n');
		
		//code
		md = md.replace(/[\`]{1}([^\`]+)[\`]{1}/g, '<code>$1</code>');
		
		//br
		md = md.replace(/(  \n)/g, '<br>');

		//p
		md = md.replace(/\s*(\n){1,}(.+)/gm, function(m){
			return  /\<(\/)?(h\d|ul|ol|li|blockquote|pre|img|div)/.test(m) ? m : '<p>'+m+'</p>';
		});
		
		//strip p from pre
		md = md.replace(/(\<pre.+\>)([\S\s]*?)(?=\<\/pre\>)(\<\/pre\>)/gm, (m, a, b, c) => {
			b = b.replace(/(\<p\>)([\S\s]*?)(?=\<\/p\>)(\<\/p\>)/gm, '$2');
			return a + b + c;
		});
		
		return md;
	}

	constructor() {
		this._name;
		this._value;

		this._noId = false;
		this._optionElem;
	}

	get name() {return this._name;}
	set name(v) {this._name = v;}

	get value() {
		if (this._value == null && this._name !== null) {
			API.fetch('topics/' + this._name)
			.then(json => {
				if (json.noId) this._noId = true;
				this._value = json._value;
				document.dispatchEvent(new Event('helpLoadComplete'));
			});
			return 'loading';
		}
		else {
			return this._value;
		}
	}
	set value(v) {this._value = v;}

	get parsed() {return HelpTopic.parse(this.value);}

	get selectOption() {
		
		if (this._optionElem == null) {
			this._optionElem = option(this._name, null);
		}

		return this._optionElem;
	}

	save(newName) {
		if (newName == '' || newName == null) return;
		
		let id = this._noId ? false : this._name;
		let body = {data: this._value};
		if (this._noId || newName != this._name) body.name = newName;
		
		API.upsert('topics', id, body);
		
		if (this._noId) this._noId = false;
		if (newName != this._name) {
			this._name = newName;
			if (this._optionElem != null) {
				this._optionElem.innerHTML = this._name;
			}
		}
	}
}